import axios, { AxiosInstance } from "axios";

export const api = axios.create({
  baseURL: `https://clumsy-fly-purse.cyclic.app/api`,
});


// https://clumsy-fly-purse.cyclic.app
// http://localhost:8000
